import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { FormFeedback, Input } from 'reactstrap';
import FabricOrderAction from 'store/fabric-order-resource/actions';
import ReadOnlyInput from './ReadOnlyInput';

function SelectBunch(props) {
  const dispatch = useDispatch()
  const store = useSelector(state => state)
  const { validation, edit, detail, detailIndex } = props
  const { setFieldValue, handleBlur, handleChange, values, errors, touched } = validation

  const onChange = e => {
    if (e) {
      dispatch(FabricOrderAction.getListNumber({ id: values.tradingCompanyId, brand: detail.brand, bunch: e.label }))
      setFieldValue(`details.${detailIndex}.bunch`, e.label)
    } else {
      setFieldValue(`details.${detailIndex}.bunch`, '')
      setFieldValue(`details.${detailIndex}.fabricId`, '')

    }

  }

  if (edit || !detail.isIgarashi || detail.activeColumn == 1 || !detail.brand) {
    return <ReadOnlyInput value={detail.bunch} />
  }


  return (
    <>
      <Select
        isLoading={store.fabricOrder.bunch.loading}
        isDisabled={edit}
        options={store.fabricOrder.bunch.data.map(i => ({ value: i, label: i }))}
        defaultValue={{
          value: detail.bunch,
          label: detail.bunch
        }}
        value={{
          value: detail.bunch,
          label: detail.bunch
        }}
        onChange={onChange}
        isClearable
        menuPortalTarget={document.body}
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      />
    </>
  );
}

export default SelectBunch;